module.exports = __webpack_public_path__ + "media/images/malvinas/Iso_2-38593472cbf8a6f7ea3ab2bbba781ff7.svg";